import { createApp } from 'vue';
import JpgToWebpConverter from '../Components/JpgToWebpConverter.vue';

const root = document.getElementById('jpg-to-webp-converter');
if (root) {
  createApp(JpgToWebpConverter).mount('#jpg-to-webp-converter');
}
